import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { FDLMService } from '../services/FDLM.Service';

@Injectable({
  providedIn: 'root',
})

export class AuthGuard  {

  constructor(private router: Router,
     private FDLMService: FDLMService  ) {

  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const usuario = this.FDLMService.usuarioData;
    let url: string = state.url;

    if (usuario) {
      return true;
    }
    else {
      this.FDLMService.redirectUrl = url;
      this.router.navigate(['/login']);
      return false;
    }

  }
}
